import React, { useEffect, useState } from "react";
import styles from "./StudentLoansHero.module.css";
import Image from "next/image";

interface Image {
  id: number;
  documentId: string;
  url: string;
  alternativeText: string | null;
}

interface FinancialAssistanceData {
  id: number;
  title: string;
  desktop_img: Image;
  mobile_img: Image;
  description: string | null;
}

interface Props {
  data: FinancialAssistanceData;
}

const StudentFundingHero: React.FC<Props> = ({ data }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Ensure this runs only on the client side (browser)
    if (typeof window !== "undefined") {
      const handleResize = () => {
        setIsMobile(window.innerWidth <= 767);
      };

      handleResize();
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }
  }, []);
  const { title, desktop_img, mobile_img } = data;
  return (
    <div
      className={styles.heroBanner}
      style={{
        backgroundImage: `url(${isMobile ? mobile_img.url : desktop_img.url})`,
      }}
      aria-label={desktop_img.alternativeText || "student Funding"}
    >
      <div className={styles.overlay}>
        <h1 className={styles.title}>{title}</h1>
      </div>
    </div>
  );
};

export default StudentFundingHero;
